import React          from 'react';
import { Observe }         from 'rewire-core';
import { IActionMenuItem } from 'rewire-ui';
import KeyboardArrowLeft   from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight  from '@material-ui/icons/KeyboardArrowRight';
import IconButton          from '@material-ui/core/IconButton';
import { makeStyles }      from '@material-ui/core/styles';
import TablePagination     from '@material-ui/core/esm/TablePagination/TablePagination';
import Typography          from '@material-ui/core/Typography';
import OptionsActionMenu   from '../ui/OptionsActionMenu';
import { IPaging }         from './PagingModel';

const usePaginationActionStyles = makeStyles(theme => ({
  root: {
    flexShrink: 0,
    display: 'flex',
    color: theme.palette.text.secondary,
    marginLeft: '10px',
  },
  arrowIconButtonRoot: {
    '&>span>svg': {
      fontSize: '2.2rem',
    },
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    '&$arrowIconButtonDisabled': {
      color: 'inherit',
      opacity: 0.4,
    },
  },
  arrowIconButtonDisabled: {
  },
}));

function TablePaginationActions(props: any) {
  const classes = usePaginationActionStyles(props);
  const { count, page, rowsPerPage, onPageChange, options, children, loading } = props;

  function handleBackButtonClick(event: any) {
    onPageChange(event, page - 1);
  }

  function handleNextButtonClick(event: any) {
    onPageChange(event, page + 1);
  }

  return (
    <div className={classes.root}>
      <IconButton classes={{root: classes.arrowIconButtonRoot, disabled: classes.arrowIconButtonDisabled}} onClick={handleBackButtonClick} disabled={loading || (page === 0)} aria-label='Previous Page'>
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton classes={{root: classes.arrowIconButtonRoot, disabled: classes.arrowIconButtonDisabled}} onClick={handleNextButtonClick} disabled={loading || (page >= Math.ceil(count / rowsPerPage) - 1)} aria-label='Next Page'>
        <KeyboardArrowRight />
      </IconButton>
      {children}
      {options && <OptionsActionMenu items={options} />}
    </div>
  );
}

const usePaginationStyles = makeStyles(_theme => ({
  root: {
    display: 'flex',
    flexShrink: 0,
    overflow: 'hidden',
  },
  hidden: {
    // display: 'none',
  },
  selectIcon: {
    top: 'calc(50% - 1.5rem)',
    fontSize: '3rem',
    marginRight: '-1rem',
  },
  groupLabel: {
    marginRight: '10px',
    fontSize: '0.875rem',
  },
  groupValue: {
    marginLeft: '2px',
    marginRight: '20px',
    fontSize: '0.875rem',
  }
}));

interface IPagingProps {
  paging:          IPaging,
  className?:      string,
  classes?:        any,
  actionsClasses?: any,
  options?:        IActionMenuItem[],
  actions?:        React.ReactNode,
  hidePageCounts?: boolean
}

export default (props: IPagingProps) => {
  const { paging, className, classes, actionsClasses, actions, options, hidePageCounts } = props;
  const paginationClasses = usePaginationStyles({classes});

  return (
    <Observe>{() => {
      return (
        <>
        { hidePageCounts && <><Typography className={paginationClasses.groupLabel}>Groups per page:</Typography><Typography className={paginationClasses.groupValue}>5</Typography></> }
        <TablePagination
          classes={{root: paginationClasses.root, toolbar: className, caption: hidePageCounts && paginationClasses.hidden || '', input: hidePageCounts && paginationClasses.hidden || '', selectIcon: paginationClasses.selectIcon || '', ...classes}}
          rowsPerPageOptions={hidePageCounts ? [5] : [15, 25, 50, 100]}
          component='div'
          count={paging.count}
          rowsPerPage={paging.itemsPerPage}
          page={paging.page}
          ActionsComponent={(props) =>
            <Observe>{() => (
              <TablePaginationActions options={options} loading={paging.loading} classes={actionsClasses} {...props}>{actions}</TablePaginationActions>
            )}</Observe>
          }
          onPageChange={(_event: any, page: number) => {
            if (page > paging.page) paging.next();
            if (page < paging.page) paging.previous();
          }}
          onRowsPerPageChange={((evt: any) => paging.itemsPerPage = parseInt(evt.target.value, 10)) as any}
        />
        </>
      );
    }}</Observe>
  );
};
